import type {
  ParameterDefinitionInOut,
  ParameterDimensionDefinitionInOut,
} from '@festina/configuration-general-types/configuration'

export type ParameterDetailsField =
  | ParameterDefinitionInOut
  | ParameterDimensionDefinitionInOut

export const isParameterDefinitionInOutFromParameterDetailsField = (
  field: ParameterDetailsField,
): field is ParameterDefinitionInOut =>
  field._type === 'ParameterDefinitionInOut'

export const isParameterDimensionDefinitionInOutFromParameterDetailsField = (
  field: ParameterDetailsField,
): field is ParameterDimensionDefinitionInOut =>
  field._type === 'ParameterDimensionDefinitionInOut'
